import React from 'react';
import classNames from 'classnames';
import { IconProp } from 'models/Icon';

import './ListingBanner.styles.scss';
import './ListingBanner.styles.responsive.scss';

type ListingBannerProps = {
  className?: string;
  title: string;
  description?: string;
  icon?: IconProp;
  color?: 'green' | 'orange' | 'neutral' | 'red';
};

const ListingBanner: React.FC<ListingBannerProps> = (props) => {
  const {
    children,
    className,
    description,
    title,
    icon: Icon,
    color = 'orange',
  } = props;

  const classes = classNames('listing-banner', color, className);

  return (
    <div className={classes}>
      <div className="listing-banner__main">
        {Icon && <Icon />}
        <div>
          <p>{title}</p>
          {description && <p className="description">{description}</p>}
        </div>
      </div>
      {children && <div className="listing-banner__actions">{children}</div>}
    </div>
  );
};

export default ListingBanner;
